import { NewsContentType } from '@/types/enum';
import image1 from '@/assets/images/news/detail/20210308/1.jpg';
import image2 from '@/assets/images/news/detail/20210308/2.png';
import image3 from '@/assets/images/news/detail/20210308/3.jpg';
import image4 from '@/assets/images/news/detail/20210308/4.jpg';
import image5 from '@/assets/images/news/detail/20210308/5.jpg';
import image6 from '@/assets/images/news/detail/20210308/6.jpg';
import image7 from '@/assets/images/news/detail/20210308/7.jpg';

export default {
  id: '20210308', //  模块 id
  title: '表白我眼里那个最美的她——女神节活动征集入选', // 标题
  origin: '', // 新闻来源
  editor: '', // 编辑者
  content: [
    {
      type: NewsContentType.Text,
      text:
        '在今年女神节来临的之际，我们发起了“别样女神节，表白我眼里那个最美的她”活动，收到了不少表白投稿，让我们一起看看叮咚小伙伴都有哪些想说的吧~',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Text,
      text: '叮咚的超人妈妈',
    },
    {
      type: NewsContentType.Image,
      src: [image1],
    },
    {
      type: NewsContentType.Text,
      text:
        '我蒙姐（高蒙）是我初来乍到却能自来熟的小伙伴。我们组的咖啡、奶茶、洗干净削好皮的水果供应商；打扫家务的一把好手，每次都帮我洗饭盒；两个可爱女儿的超人妈妈，即使凌晨四点多女儿把她吵醒无法再入睡，在提到女儿的时候满满全是爱，丝毫感受不到疲惫和抱怨；下雨懒得打伞，说自己有大头的独立坚强打工人。',
    },
    {
      type: NewsContentType.Text,
      text: '希望我蒙姐，平安喜乐，万事顺遂！',
    },
    {
      type: NewsContentType.Text,
      text: '供应链系统中心-供应链数据部 孟莹莹',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Text,
      text: '有你在，我很安心',
    },
    {
      type: NewsContentType.Image,
      src: [image2],
    },
    {
      type: NewsContentType.Text,
      text:
        '我的女朋友，她叫张雅茹。她本是一个大大咧咧的姑娘，和我在一起之后变得心细了起来。这张照片是我们去年国庆丽江之行，自驾在去玉龙雪山的路上。山路崎岖，天气也燥热难耐，我们一起克服了炎热困倦和高原反应，有她在，我很安心。从那一刻起，我在心里许诺，这辈子就是她了。女神节来临之际，希望和她在一起的每一天都能够开开心心，也祝福所有的女孩子都有幸福的另一半。',
    },
    {
      type: NewsContentType.Text,
      text: '浙江城市分选中心-杭州仁和蔬果仓-计划数据组 王瑶瑶',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Text,
      text: '致为生活努力的我们',
    },
    {
      type: NewsContentType.Image,
      src: [image3],
    },
    {
      type: NewsContentType.Text,
      text:
        '在家庭中，我们是女儿、是妻子、也是妈妈；在工作中，有我们的领头羊、区域多次拿奖的女站长；有我们的美女仓管，作为前置仓的大管家，她把站内打理的井井有条；更有我们可爱的分拣小姐姐，每日奔跑在仓库的角角落落.....如果我们前置仓是一个大家庭，而让这个大家庭越来越好的女主人公就是可爱的她们。',
    },
    {
      type: NewsContentType.Text,
      text: '上海事业部-景和服务站 魏凤',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Text,
      text: '妈妈，永远开心呀',
    },
    {
      type: NewsContentType.Image,
      src: [image4],
    },
    {
      type: NewsContentType.Text,
      text:
        '妈妈在2009年查出良性甲状腺瘤，同年5月份做了摘除手术，医生叮嘱妈妈少生气。可我在和妈妈打电话也常常因为小事惹妈妈生气，我没有做一个可以让妈妈一直开心的小棉袄。',
    },
    {
      type: NewsContentType.Text,
      text:
        '今年春节期间我们一家到家乡的小九华山游玩，妈妈的本命年就趁机拍下了这张“牛气”照片，照片里的妈妈开心的像孩童。希望妈妈永远开开心心，少生气，滚蛋吧小瘤子！',
    },
    {
      type: NewsContentType.Text,
      text: '财务部-应付组 余静',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Text,
      text: '养儿方知父母恩',
    },
    {
      type: NewsContentType.Image,
      src: [image5],
    },
    {
      type: NewsContentType.Text,
      text:
        '我的女神是我的妈妈，在我成长的过程中，印象中最深刻的一件事就是,我拒绝了妈妈安排的所有相亲，固执的选择了远嫁。爸妈虽然有很多不舍，却也只说了句：“只要你过得好就行，在哪儿都一样......”',
    },
    {
      type: NewsContentType.Text,
      text:
        '养儿方知父母恩,每每再回想起妈妈说的一句话，都忍不住不红了眼眶。小伙伴们珍惜眼前人吧，空闲的时间多给爸妈妈打打电话唠唠家常。',
    },
    {
      type: NewsContentType.Text,
      text: '苏锡城市分选中心-海盛路蔬果仓-生产部 王欢',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Text,
      text: '“讲不出动人的情话，我只想带你回家”',
    },
    {
      type: NewsContentType.Image,
      src: [image6],
    },
    {
      type: NewsContentType.Text,
      text:
        '没来成都的时候，我真的特别向往来成都，总觉得那边有什么东西在吸引着我；来了以后，我终于找到了一直吸引着我的东西，我的女孩——梁琴。从见到你的第一眼，我总感觉我们好像在哪儿见过，看到你就有一种小鹿乱撞的感觉。我这个人比较木讷，没有那么多的小惊喜，我就想对你说：“讲不出动人的情话，我只想带你回家。”',
    },
    {
      type: NewsContentType.Text,
      text:
        '妈妈，感谢你辛辛苦苦把我养育这么大。第一次送你女神节礼物，记得还是小学5年级，用零花钱送了你一个音乐盒，你当时开心的不得了，从那以后就没有送过礼物给你了。今年，我给你憋了一个大大大大礼物，我就要带着您亲爱的儿媳妇回家了！',
    },
    {
      type: NewsContentType.Text,
      text: '成都事业部-龙泉驿服务站 吉汝斌',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Text,
      text: '披荆斩棘的叮咚女神们',
    },
    {
      type: NewsContentType.Image,
      src: [image7],
    },
    {
      type: NewsContentType.Text,
      text:
        '业务系统切换中，反馈出的问题比较多，必须及时解决，否则会影响仓库效率。1月17日周日下午2:00，产品A女（绰号妙龄少女）+测试B女（绰号叮咚股神）+开发C男（绰号健身小王子）齐聚总部某楼，女神同事们和研发男神们一起讨论，昨天晚上仓库反馈问题的解决方案。',
    },
    {
      type: NewsContentType.Text,
      text:
        '“精致妆容”+“帅气外套”+“绝美侧颜”的加持下，20分钟结束会议，打工人为了项目进度放弃休息继续打工。能做叮咚女神，亦能战场披荆斩棘，可盐可甜，值得拥有喔~表白女神同事们~',
    },
    {
      type: NewsContentType.Text,
      text: '产品技术中心-小满业务部-测试组 雷黎',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Text,
      text: '跨越世纪的想念',
    },
    {
      type: NewsContentType.Text,
      text:
        '下面，分享一篇特别的散文诗，来自产品技术中心-测试部王晓磊同学，感受那跨越世纪的想念。',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Text,
      text: '《写给姥姥的散文诗》',
    },
    {
      type: NewsContentType.Text,
      text:
        '相册中，一直保留着从小舅家拿的一张照片。照片里的你，包着褐色头巾，穿着黑粗布棉衣双手撺在袖筒里取暖，神采奕奕的站在堂门前的台阶上。',
    },
    {
      type: NewsContentType.Text,
      text:
        '那是1920年，小舅结婚，摄影师拍新郎官，无意将看热闹的你也拍了进去。那时的你，像中国几百万的老太太一样，经历了无数苦难，靠辛劳的双手养活儿女，又盼他们娶妻嫁郎。',
    },
    {
      type: NewsContentType.Text,
      text: '姥姥的名字没人知道，说是您未说过',
    },
    {
      type: NewsContentType.Text,
      text:
        '一次陪姥姥去兑换国债券，看到了年久发黄的纸片上最后淡淡的一个字印：倩，必那时您也是父母手心里的一块宝，一定也是年少时的青春倩影。',
    },
    {
      type: NewsContentType.Text,
      text:
        '从有记忆起，姥姥就是个老太太，微弓着背，拄着3节竹子的拐杖，一双被旧时代包裹后的小脚走在乡间的泥土路上，从土里找生活，在路上走人生。',
    },
    {
      type: NewsContentType.Text,
      text:
        '回忆里，姥姥屋子里的柜子中，永远有冰糖和糕点，那是亲人去看望您拿的礼物，每次去看您，都让我去柜子里拿好吃的。',
    },
    {
      type: NewsContentType.Text,
      text: '脑海里，一直记得那年您带我去赶集',
    },
    {
      type: NewsContentType.Text,
      text: '买了6个香瓜让我带回了家，香瓜脆脆的，甜丝丝的。',
    },
    {
      type: NewsContentType.Text,
      text:
        '两千年的一天，突然又像约定已久，您离开了，如今，21年过去了，您的重外孙也已上了幼儿园。时间真快，每每记起那个阳光明媚的日子里，您坐在院子里，我给您端水洗头洗脚。',
    },
    {
      type: NewsContentType.Text,
      text: '倍感欣慰，总算有一件我为您做的事可以让我回忆。',
    },
    {
      type: NewsContentType.Text,
      text:
        '几十年后的今天，依然想您，想您的时候，脑海中往事的画面就一幅幅划过。如果有下辈子，想和您做同伴，做姐妹，我们一起走过您那青春倩影的年华。',
    },
    {
      type: NewsContentType.Text,
      text: '王晓磊 产品技术中心-测试部',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Text,
      text:
        '恭喜以上小伙伴征集入选，获奖小奖品将在近期寄出！再次感谢所有参与征集投稿的小伙伴！',
    },
    {
      type: NewsContentType.Text,
      text: '希望小伙伴们都能活出自己的精彩！',
    },
    {
      type: NewsContentType.Text,
      text: '永远明媚，永远积极向上！',
    },
    {
      type: NewsContentType.Text,
      text: '节日快乐，叮咚女神们！',
    },
  ],
};
